import { Button, Form, Input } from "antd"
import { Typography, Space } from "antd"
import { QrcodeOutlined, MobileOutlined } from "@ant-design/icons"
import Link from "next/link"

export function LoginForm({onSubmit,multipleFactors, onFactorSelect,showFactorChoice }){
  const [form] = Form.useForm();


  if (showFactorChoice && multipleFactors) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Typography.Title level={5} style={{ 
          color: 'white',
          textShadow: '0 2px 4px rgba(0,0,0,0.3)'}}>
            Elige método de verificación:
        </Typography.Title>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {multipleFactors.map((hint, index) => (
            <Button
              key={index}
              type="primary"
              size="large"
              icon={hint.factorId === 'totp' ? <QrcodeOutlined /> : <MobileOutlined />}
              onClick={() => onFactorSelect(hint)}
              style={{ 
                height: '40px', 
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px'
              }}
            >
              {hint.factorId === 'totp' 
                ? 'Usar aplicación de autenticación' 
                : `Recibir SMS al ${hint.phoneNumber || 'teléfono registrado'}`}
            </Button>
          ))}
        </Space>
      </div>
    );
  }

  return (
    <Form
      name="login"
      layout="vertical"
      onFinish={onSubmit}>
      <Form.Item
        name="email"
        rules={[{ required: true, message: "Por favor ingresa to correo" }]}>
        <Input />
      </Form.Item>
      <Form.Item
        name="password"
        rules={
          [{ required: true, message: "Por favor ingresa to contraseña" }]
        }>
        <Input.Password />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Iniciar sesión
        </Button>
      </Form.Item>
      <small>
        ¿Olvidaste tu contraseña?
        &nbsp;
        <Link style={{ color: '#9E6D9C' }}
        href="/recovery">
          Click aqui
        </Link>
      </small>
    </Form>
  )
}
